export default __webpack_public_path__ + "static/media/1.96a9d199.svg";